import React, { useEffect, useState, useMemo } from 'react';
import api from '../../helpers/api';
import { useAngularService } from '../../helpers/get_angular_service';
import redirect from '../../helpers/redirect';
import sources from '../../helpers/sources';
import plural from '../../helpers/plural';
import Link from '../components/link';
import Table from '../components/table';
import Dropdown from '../components/dropdown';
import notification from 'helpers/notification';

const AppointmentTypesList = () => {
  const $rootScope = useAngularService('$rootScope');
  const loadingAnimation = useAngularService('loadingAnimation');
  const GTMService = useAngularService('GTMService');
  const FeatureAvailabilityService = useAngularService('FeatureAvailabilityService');

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [appointmentTypes, setAppointmentTypesList] = useState([]);

  useEffect(() => {
    if (!FeatureAvailabilityService.isAvailable('attendance')) {
      redirect('gym.dashboard');
    }

    GTMService.trackPage('Appointment Types');
  }, []);

  const getAppointmentTypes = (currentPage = 1) => {
    setLoading(true);
    setPage(currentPage);

    const params = {
      count: 10,
      page: currentPage,
    };

    api.get(sources.appointmentTypes($rootScope.gym.id), params).then(
      (response) => {
        setAppointmentTypesList(response);
        setLoading(false);
      },
      () => {
        setLoading(true);
      },
    );
  };

  const onActionSelect = (action, item) => {
    switch (action) {
      case 'edit': {
        GTMService.trackPage('Appointment Types', 'Click to Edit');
        redirect('gym.appointmentTypes.edit', { appointmentTypeId: item.id });
        break;
      }
      case 'duplicate':
        clone(item);
        break;
      case 'delete':
        remove(item);
        break;
      default:
        break;
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        id: 'name',
        Cell: ({ row }) => (
          <Link
            route="gym.appointmentTypes.edit"
            routeParams={{ appointmentTypeId: row.original.id }}
          >
            {row.original.name}
          </Link>
        ),
      },

      {
        Header: 'Event Type',
        id: 'event_type',
        Cell: ({ row }) => <div>{row.original.event_type_name}</div>,
      },
      {
        Header: 'Duration',
        id: 'duration',
        Cell: ({ row }) => (
          <div>{plural(row.original.duration_unit, row.original.duration_number, true)}</div>
        ),
      },

      {
        Header: '',
        id: 'actions',
        Cell: ({ row }) => (
          <div className="text-right">
            <Dropdown
              options={[
                {
                  value: 'edit',
                  label: 'View / edit',
                },
                {
                  value: 'duplicate',
                  label: 'Duplicate',
                },
                {
                  value: 'delete',
                  label: 'Remove',
                },
              ]}
              onSelect={(action) => onActionSelect(action, row.original)}
              buttonType="icon-more"
            />
          </div>
        ),
      },
    ],
    [page],
  );

  const reload = () => {
    getAppointmentTypes(page);
  };

  const clone = (item) => {
    if (window.confirm('This will make a copy of the selected appointment type. Are you sure?')) {
      GTMService.trackPage('Appointment Types', 'Duplicate');
      loadingAnimation.show();
      const url = `${sources.appointmentType($rootScope.gym.id, item.id)}/clone`;
      api.put(url).then(
        () => {
          reload();
          loadingAnimation.hide();
          notification.success('Appointment type duplicated successfully');
        },
        () => {
          loadingAnimation.hide();
        },
      );
    }
  };

  const remove = (item) => {
    if (window.confirm('Are you sure you want to delete this appointment types?')) {
      GTMService.trackPage('Appointment Types', 'Delete');
      loadingAnimation.show();
      const url = `${sources.appointmentType($rootScope.gym.id, item.id)}`;
      api.delete(url).then(
        () => {
          reload();
          loadingAnimation.hide();
        },
        () => {
          loadingAnimation.hide();
        },
      );
    }
  };

  const onAdd = () => {
    GTMService.trackPage('Appointment Types', 'Add');
  };

  return (
    <section className="manage-calendar content-section">
      <header className="page-header page-header--multiple-rows">
        <h1 className="page-header__title">Appointment types</h1>
        <div className="page-header__buttons">
          <Link
            type="button"
            variant="primary--v2"
            onClick={onAdd}
            route="gym.appointmentTypes.new"
          >
            <i className="icon-plus"></i> New Appointment Type
          </Link>
        </div>
      </header>
      <div className="container">
        <Table
          columns={columns}
          data={appointmentTypes}
          loading={loading}
          emptyText="No Appointment types found"
          pageSize={10}
          loadData={(page) => getAppointmentTypes(page)}
          variant="v2"
        />
      </div>
    </section>
  );
};

angular.module('gym').value('AppointmentTypesList', AppointmentTypesList);
